/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Guedder API
 * Contrato oficial da API v3 do Guedder (API-First).
 *
 * ## Modelo de resposta
 *
 * A v3 NÃO usa envelope. O status HTTP 2xx já comunica sucesso e o cliente
 * gerado é uma sealed-union por status-code. Sem `success`/`code`/`message` de
 * cerimônia. Respostas de objeto único retornam o tipo de domínio diretamente:
 * ```json
 * // 200 GET /api/v3/eventos/{eventoId}  → DadosBasicosEventoDto
 * { "id": "...", "nome": "..." }
 * ```
 *
 * ## Paginação
 *
 * TODA resposta de coleção usa um único shape canônico `Paged<T>`:
 * ```json
 * // 200 GET /api/v3/eventos  → Paged<DadosBasicosEventoDto>
 * { "content": [ { "id": "...", "nome": "..." } ], "page": { PageInfo } }
 * ```
 * `PageInfo` é offset-based, compatível com Spring Data `Page<T>`. Coleções
 * bounded (categorias, carrossel de destaque, devices, line-up) retornam uma
 * página única; params reais (`page`/`size`/`sort`) podem ser adicionados depois
 * sem quebrar o contrato (adição não-breaking).
 *
 * ## Erros
 *
 * Erro tem um único modelo: RFC 7807 (`ProblemDetail`), gerado nativamente pelo
 * Spring 6+. Validação de campo vem em `errors[]` dentro do próprio ProblemDetail.
 * ```json
 * { "type": "...", "title": "Not Found", "status": 404, "detail": "..." }
 * ```
 *
 * ## Convenções v3.1
 *
 * A v3.1 consolida as convenções de nomeação de recursos:
 * - **Sem sufixo `/publico`**: endpoints públicos não carregam mais o sufixo
 *   `/publico` no path; a ausência de `security` já comunica que são abertos.
 * - **Recursos plurais em kebab-case**: coleções usam nomes plurais
 *   (`/eventos`, `/ingressos`, `/compras`, `/cotacoes`) e paths compostos usam
 *   kebab-case (`/notification-tokens`, `/categorias-evento`,
 *   `/transferencias-pendentes`, `/wallet-config`).
 * - **Sub-recursos aninhados sob `/eventos`**: atrações, lotes, parâmetros de
 *   venda, visualizações e ingressos de check-in são modelados como
 *   sub-recursos de `/eventos/{eventoId}/...`.
 * - **Dois enums distintos para ingresso**: `StatusPagamentoIngresso` (estado
 *   de pagamento) e `CicloDeVidaIngresso` (eixo temporal: ativo/encerrado)
 *   deixam de ser misturados em um único enum. A custódia do ingresso
 *   (transferência em curso) é um terceiro eixo, servido pelo recurso
 *   `/transferencias-pendentes` — ver ADR-0016.
 *
 * ## Caixa dos enums
 *
 * Todo enum desta API é aceito em **qualquer caixa** na entrada — em query
 * params, path params e corpo JSON. `?cicloDeVida=ativo`, `Ativo` e `ATIVO`
 * são equivalentes.
 *
 * Isto é uma garantia do contrato, não um detalhe de implementação: existe
 * para que URLs compartilháveis e chamadas escritas à mão (curl, Postman)
 * não precisem carregar o valor em maiúsculo, que é desconfortável de ler e
 * digitar.
 *
 * A **saída** continua sempre no valor canônico em MAIÚSCULO. Clientes devem
 * comparar respostas contra o valor canônico, nunca assumir a caixa que
 * enviaram.
 *
 * ## Datas e fuso horário
 *
 * Datas têm **dois tipos distintos** neste contrato (ADR-0009), hoje
 * confundidos sob o mesmo `format: date-time`:
 *
 * - **Instante de auditoria** — `dataCriacao`, `dataCompra`, `dataCheckin`,
 *   `checkIn`, `realizadoEm`, `ProblemDetail.timestamp`. É um instante UTC
 *   (`...Z`); a zona não é semanticamente relevante e o valor deve ser
 *   renderizado no fuso do dispositivo.
 * - **Hora-de-parede do evento** — `dataInicio`, `dataFim`, `inicioVendas`,
 *   `terminoVendas`, `dataInicioSessao`/`dataFimSessao`,
 *   `inicioCheckin`/`terminoCheckin`, `dataEvento`, `dataFimEvento`. Também
 *   viaja como instante UTC no fio, mas representa uma hora local num lugar:
 *   deve ser renderizada **no fuso do evento**.
 *
 * Cada campo diz a qual dos dois pertence, na própria `description`.
 *
 * Todo recurso que carrega hora-de-parede expõe um campo `timezone` (IANA,
 * ex.: `America/Sao_Paulo`) — inclusive os que apenas desnormalizam a data de
 * um evento (ingresso, transferência, repasse), justamente para o cliente
 * nunca precisar buscar o evento só para saber em que fuso renderizar.
 *
 * **Renderizar hora-de-parede no fuso do dispositivo, ou com offset chumbado
 * (`-0300`), é incorreto**: quebra em horário de verão e em qualquer evento
 * fora do Brasil. Cada cliente usa sua ferramenta nativa
 * (`Temporal.ZonedDateTime` no web, `package:timezone` no Flutter) — o padrão
 * compartilhado é o contrato, não a biblioteca.
 *
 * Nas **requisições**, todo valor `format: date-time` (corpo ou query param)
 * deve carregar offset explícito ISO-8601 — `Z` ou `±hh:mm`. Não existe fuso
 * implícito de servidor: omitir o offset é erro do cliente. Já `format: date`
 * (ex.: `dataNascimento`) é data de calendário, sem hora e sem fuso — a regra
 * não se aplica.
 *
 * Duas exceções de compatibilidade Sympla em `GET /api/v3/eventos`, ambas
 * fora da convenção acima: os params `from`/`to` usam o formato Sympla
 * `YYYY-MM-DD[ HH:mm:ss]` interpretado em UTC e **não** aceitam offset; e o
 * param `timezone` daquela rota é filtro de compatibilidade — **não** é o
 * fuso do evento.
 *
 * ## Retrocompatibilidade
 *
 * Os paths `/api/v1/...` e `/api/v2/...` permanecem funcionais com seu próprio
 * envelope `RestObject`. A v3 diverge deliberadamente dessa simetria (ver ADR
 * de modelagem de resposta v3): é superfície nova, contract-first, gerada.
 * Os clients gerados apontam para `/api/v3/...`.
 *
 * OpenAPI spec version: 3.8.0
 */
import {
  HttpClient,
  HttpParams
} from '@angular/common/http';

import {
  inject
} from '@angular/core';

import {
  injectQuery
} from '@tanstack/angular-query-experimental';
import type {
  CreateQueryOptions,
  CreateQueryResult,
  QueryFunction
} from '@tanstack/angular-query-experimental';

import {
  fromEvent,
  lastValueFrom
} from 'rxjs';

import {
  takeUntil
} from 'rxjs/operators';

import type {
  BadRequestResponse,
  BuscarIngressosPorEventoParams,
  EntityFilterDTO,
  EntityMetaDTO,
  ForbiddenResponse,
  GetMeusIngressosParams,
  GetResumoMeusIngressosParams,
  PagedIngresso,
  PagedIngressosCheckIn,
  PagedResumoIngressosEvento,
  UnauthorizedResponse
} from '../schemas';




type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}
export const getMeusIngressos = (
    http: HttpClient,
    params?: GetMeusIngressosParams, options?: { signal?: AbortSignal | null }
  ): Promise<PagedIngresso> => {

    const httpParams = params ? new HttpParams({ fromObject: filterParams(params, new Set<string>([])) }) : undefined;
    const url = `/api/v3/ingressos`;
    const request$ = http.get<PagedIngresso>(url, { params: httpParams });
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getGetMeusIngressosQueryKey = (params?: GetMeusIngressosParams,) => {
    return [
    `/api/v3/ingressos`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMeusIngressosQueryOptions = <TData = Awaited<ReturnType<typeof getMeusIngressos>>, TError = UnauthorizedResponse>(http: HttpClient, params?: GetMeusIngressosParams, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getMeusIngressos>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeusIngressosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeusIngressos>>> = ({ signal }) => getMeusIngressos(http, params, { signal, ...fetchOptions });





   return  { queryKey, queryFn, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof getMeusIngressos>>, TError, TData>
}

export type GetMeusIngressosQueryResult = NonNullable<Awaited<ReturnType<typeof getMeusIngressos>>>
export type GetMeusIngressosQueryError = UnauthorizedResponse


/**
 * @summary Lista paginada dos ingressos do comprador autenticado
 */

export function injectGetMeusIngressos<TData = Awaited<ReturnType<typeof getMeusIngressos>>, TError = UnauthorizedResponse>(
 params?: GetMeusIngressosParams | (() => GetMeusIngressosParams | undefined), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getMeusIngressos>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getMeusIngressos>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _params = typeof params === 'function' ? params() : params;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getGetMeusIngressosQueryOptions(http, _params, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const getResumoMeusIngressos = (
    http: HttpClient,
    params?: GetResumoMeusIngressosParams, options?: { signal?: AbortSignal | null }
  ): Promise<PagedResumoIngressosEvento> => {

    const httpParams = params ? new HttpParams({ fromObject: filterParams(params, new Set<string>([])) }) : undefined;
    const url = `/api/v3/ingressos/resumo`;
    const request$ = http.get<PagedResumoIngressosEvento>(url, { params: httpParams });
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getGetResumoMeusIngressosQueryKey = (params?: GetResumoMeusIngressosParams,) => {
    return [
    `/api/v3/ingressos/resumo`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetResumoMeusIngressosQueryOptions = <TData = Awaited<ReturnType<typeof getResumoMeusIngressos>>, TError = UnauthorizedResponse>(http: HttpClient, params?: GetResumoMeusIngressosParams, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getResumoMeusIngressos>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResumoMeusIngressosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResumoMeusIngressos>>> = ({ signal }) => getResumoMeusIngressos(http, params, { signal, ...fetchOptions });





   return  { queryKey, queryFn, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof getResumoMeusIngressos>>, TError, TData>
}

export type GetResumoMeusIngressosQueryResult = NonNullable<Awaited<ReturnType<typeof getResumoMeusIngressos>>>
export type GetResumoMeusIngressosQueryError = UnauthorizedResponse


/**
 * @summary Carteira agrupada por evento, agregada no servidor
 */

export function injectGetResumoMeusIngressos<TData = Awaited<ReturnType<typeof getResumoMeusIngressos>>, TError = UnauthorizedResponse>(
 params?: GetResumoMeusIngressosParams | (() => GetResumoMeusIngressosParams | undefined), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getResumoMeusIngressos>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof getResumoMeusIngressos>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _params = typeof params === 'function' ? params() : params;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getGetResumoMeusIngressosQueryOptions(http, _params, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const buscarIngressosPorEvento = (
    http: HttpClient,
    eventoId: string,
    params?: BuscarIngressosPorEventoParams, options?: { signal?: AbortSignal | null }
  ): Promise<PagedIngressosCheckIn> => {

    const httpParams = params ? new HttpParams({ fromObject: filterParams(params, new Set<string>([])) }) : undefined;
    const url = `/api/v3/eventos/${eventoId}/ingressos`;
    const request$ = http.get<PagedIngressosCheckIn>(url, { params: httpParams });
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getBuscarIngressosPorEventoQueryKey = (eventoId: string,
    params?: BuscarIngressosPorEventoParams,) => {
    return [
    `/api/v3/eventos/${eventoId}/ingressos`, ...(params ? [params] : [])
    ] as const;
    }


export const getBuscarIngressosPorEventoQueryOptions = <TData = Awaited<ReturnType<typeof buscarIngressosPorEvento>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse>(http: HttpClient, eventoId: string,
    params?: BuscarIngressosPorEventoParams, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof buscarIngressosPorEvento>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuscarIngressosPorEventoQueryKey(eventoId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof buscarIngressosPorEvento>>> = ({ signal }) => buscarIngressosPorEvento(http, eventoId,params, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof buscarIngressosPorEvento>>, TError, TData>
}

export type BuscarIngressosPorEventoQueryResult = NonNullable<Awaited<ReturnType<typeof buscarIngressosPorEvento>>>
export type BuscarIngressosPorEventoQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse


/**
 * @summary Lista ingressos de um evento para check-in (acesso produtor/admin)
 */

export function injectBuscarIngressosPorEvento<TData = Awaited<ReturnType<typeof buscarIngressosPorEvento>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse>(
 eventoId: string | (() => string),
    params?: BuscarIngressosPorEventoParams | (() => BuscarIngressosPorEventoParams | undefined), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof buscarIngressosPorEvento>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof buscarIngressosPorEvento>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    const _params = typeof params === 'function' ? params() : params;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getBuscarIngressosPorEventoQueryOptions(http, _eventoId, _params, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const buscarFiltrosDeIngressos = (
    http: HttpClient,
    eventoId: string, options?: { signal?: AbortSignal | null }
  ): Promise<EntityFilterDTO[]> => {

    const url = `/api/v3/eventos/${eventoId}/ingressos/filtros`;
    const request$ = http.get<EntityFilterDTO[]>(url);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getBuscarFiltrosDeIngressosQueryKey = (eventoId: string,) => {
    return [
    `/api/v3/eventos/${eventoId}/ingressos/filtros`
    ] as const;
    }


export const getBuscarFiltrosDeIngressosQueryOptions = <TData = Awaited<ReturnType<typeof buscarFiltrosDeIngressos>>, TError = UnauthorizedResponse | ForbiddenResponse>(http: HttpClient, eventoId: string, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof buscarFiltrosDeIngressos>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuscarFiltrosDeIngressosQueryKey(eventoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof buscarFiltrosDeIngressos>>> = ({ signal }) => buscarFiltrosDeIngressos(http, eventoId, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof buscarFiltrosDeIngressos>>, TError, TData>
}

export type BuscarFiltrosDeIngressosQueryResult = NonNullable<Awaited<ReturnType<typeof buscarFiltrosDeIngressos>>>
export type BuscarFiltrosDeIngressosQueryError = UnauthorizedResponse | ForbiddenResponse


/**
 * @deprecated
 * @summary Catálogo de filtros aceitos por `GET /api/v3/eventos/{eventoId}/ingressos`
 */

export function injectBuscarFiltrosDeIngressos<TData = Awaited<ReturnType<typeof buscarFiltrosDeIngressos>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 eventoId: string | (() => string), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof buscarFiltrosDeIngressos>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof buscarFiltrosDeIngressos>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getBuscarFiltrosDeIngressosQueryOptions(http, _eventoId, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






export const buscarMetaDeIngressos = (
    http: HttpClient,
    eventoId: string, options?: { signal?: AbortSignal | null }
  ): Promise<EntityMetaDTO> => {

    const url = `/api/v3/eventos/${eventoId}/ingressos/meta`;
    const request$ = http.get<EntityMetaDTO>(url);
    if (options?.signal) {
      return lastValueFrom(request$.pipe(takeUntil(fromEvent(options.signal, 'abort'))));
    }
    return lastValueFrom(request$);
  }




export const getBuscarMetaDeIngressosQueryKey = (eventoId: string,) => {
    return [
    `/api/v3/eventos/${eventoId}/ingressos/meta`
    ] as const;
    }


export const getBuscarMetaDeIngressosQueryOptions = <TData = Awaited<ReturnType<typeof buscarMetaDeIngressos>>, TError = UnauthorizedResponse>(http: HttpClient, eventoId: string, options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof buscarMetaDeIngressos>>, TError, TData>>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuscarMetaDeIngressosQueryKey(eventoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof buscarMetaDeIngressos>>> = ({ signal }) => buscarMetaDeIngressos(http, eventoId, { signal, ...fetchOptions });





   return  { queryKey, queryFn, enabled: eventoId !== null && eventoId !== undefined, ...queryOptions} as CreateQueryOptions<Awaited<ReturnType<typeof buscarMetaDeIngressos>>, TError, TData>
}

export type BuscarMetaDeIngressosQueryResult = NonNullable<Awaited<ReturnType<typeof buscarMetaDeIngressos>>>
export type BuscarMetaDeIngressosQueryError = UnauthorizedResponse


/**
 * @summary Filtros e ordenações de `GET /api/v3/eventos/{eventoId}/ingressos`
 */

export function injectBuscarMetaDeIngressos<TData = Awaited<ReturnType<typeof buscarMetaDeIngressos>>, TError = UnauthorizedResponse>(
 eventoId: string | (() => string), options?: { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof buscarMetaDeIngressos>>, TError, TData>>, fetch?: RequestInit} | (() => { query?:Partial<CreateQueryOptions<Awaited<ReturnType<typeof buscarMetaDeIngressos>>, TError, TData>>, fetch?: RequestInit})

 ): CreateQueryResult<TData, TError> {

  const http = inject(HttpClient);

  const query = injectQuery(() => {
    // Resolve params if getter function (for signal reactivity)
    const _eventoId = typeof eventoId === 'function' ? eventoId() : eventoId;
    // Resolve options if getter function (for signal reactivity)
    const _options = typeof options === 'function' ? options() : options;
    return getBuscarMetaDeIngressosQueryOptions(http, _eventoId, _options);
  }) as CreateQueryResult<TData, TError>;

  return query;
}






